module.exports = __webpack_public_path__ + "img/logo-we4u.1dc3d78e.png";